module.exports = __webpack_public_path__ + "img/p15.227d2876.png";